module.exports = __webpack_public_path__ + "img/progressive-logo.c95267a9.svg";